import type { SubscribePayload } from 'graphql-ws';
import {
	type SubscribeFunction,
	Observable,
	type RequestParameters,
	type Variables,
} from 'relay-runtime';
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { getClient } from '@atlassian/jira-graphql-subscription/src/utils/client/index.tsx';
import {
	type SinkError,
	getSinkError,
} from '@atlassian/jira-graphql-subscription/src/utils/sink/index.tsx';
import { getUserLocation } from '@atlassian/jira-platform-router-utils/src/common/utils/index.tsx';
import { functionWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { fg } from '@atlassian/jira-feature-gating';
import { subscribe as subscribeNew } from '@atlassian/relay-subscription';

export const subscribeOld: SubscribeFunction = (
	{ id, name: operationName }: RequestParameters,
	variables: Variables,
) =>
	Observable.create((sink) => {
		const client = getClient();
		if (!client) {
			return sink.error(new Error('Unable to create subscription client'));
		}

		const payload: SubscribePayload = {
			query: '',
			operationName,
			variables,
			extensions: {
				pq: id,
			},
		};

		let requestId: string | null;

		return client.subscribe(payload, {
			...sink,
			next: (value) => {
				// @ts-expect-error agg prop is missing on generic "extensions" type
				const aggRequestId = value?.extensions?.gateway?.request_id;
				requestId = aggRequestId ?? requestId;
				// @ts-expect-error incompatible types between two libraries
				sink.next(value);
			},
			error: (sinkError: SinkError) => {
				const errorInfo = getSinkError(sinkError);
				const attributes = { operationName, requestId, userLocation: getUserLocation() };

				sink.error(errorInfo);

				fireErrorAnalytics({
					meta: {
						id: 'subscription',
						packageName: 'jiraRelaySubscription',
						teamName: 'uip-graphql',
					},
					error: errorInfo,
					attributes,
					sendToPrivacyUnsafeSplunk: true,
				});
			},
		});
	});

export const subscribe = functionWithCondition(
	() => fg('moving_relay_subscriptions_under_platform'),
	subscribeNew,
	subscribeOld,
);
